import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mx-auto py-8" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row justify-start sm:justify-between items-start sm:items-center px-4 sm:px-0" }
const _hoisted_3 = { class: "space-y-0" }
const _hoisted_4 = { class: "text-gray-300 uppercase" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Total Saved")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Total Loss")
const _hoisted_7 = { class: "text-right flex flex-col sm:flex-row mt-6 sm:mt-0 items-start sm:items-center space-y-2 sm:space-y-0 w-full sm:w-auto" }
const _hoisted_8 = { class: "text-gray-300 text-base sm:text-xl pr-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Add Expense", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Save", -1)
const _hoisted_11 = { class: "container mx-auto hidden sm:block" }
const _hoisted_12 = { class: "grid grid-cols-2 gap-6 md:flex md:flex-row md:justify-between items-center mt-8" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AddIcon = _resolveComponent("AddIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_SaveIcon = _resolveComponent("SaveIcon")
  const _component_BudgetEditTotal = _resolveComponent("BudgetEditTotal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["w-full", { 'bg-dark-danger': !_ctx.isGain, 'bg-dark-primary': _ctx.isGain }]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, [
              (_ctx.isGain)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_5
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("", true),
              (!_ctx.isGain)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_6
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("", true)
            ]),
            _createVNode("p", {
              class: ["text-4xl font-body font-bold", {
							'text-danger': !_ctx.isGain,
							'text-primary': _ctx.isGain,
						}]
            }, " $" + _toDisplayString(_ctx.totalSaved.replace('-', '')), 3)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.cycle), 1),
            _createVNode(_component_Button, {
              color: "secondary",
              class: "w-full sm:w-auto",
              "onOn-click": _cache[1] || (_cache[1] = $event => (_ctx.addExpense()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AddIcon, { class: "w-5 h-5" }),
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              color: "primary",
              class: "w-full sm:w-auto",
              "is-disabled": _ctx.disableSave,
              "onOn-click": _cache[2] || (_cache[2] = $event => (_ctx.saveBudget()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SaveIcon, { class: "w-5 h-5" }),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["is-disabled"])
          ])
        ])
      ])
    ], 2),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_BudgetEditTotal, {
          class: "justify-center md:justify-start",
          amount: _ctx.totalEarned,
          icon: "CashIcon",
          title: "Total Earned"
        }, null, 8, ["amount"]),
        _createVNode(_component_BudgetEditTotal, {
          class: "justify-center md:justify-start",
          amount: _ctx.totalSpent,
          icon: "ShoppingBagIcon",
          title: "Total Spent"
        }, null, 8, ["amount"]),
        _createVNode(_component_BudgetEditTotal, {
          class: "justify-center md:justify-start",
          amount: _ctx.totalInvested,
          icon: "ReceiptTaxIcon",
          title: "Total Invested"
        }, null, 8, ["amount"]),
        _createVNode(_component_BudgetEditTotal, {
          class: "justify-center md:justify-start",
          amount: _ctx.totalBanked,
          icon: "LibraryIcon",
          title: "Total Banked"
        }, null, 8, ["amount"])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}